import { isPopoverOpen } from "./exclusive-popover.util"

/**
 * Adds "F" keyboard shortcut to toggle a filter menu popover.
 * Works with any Stimulus controller that has `filterMenuTarget`, `filterButtonTarget`,
 * `openFilterMenu()`, and `closeFilterMenu()` methods.
 *
 * Usage in a Stimulus controller:
 *   import { installFilterHotkey } from "../../utils/filter-hotkey.util"
 *
 *   connect() {
 *     this.removeFilterHotkey = installFilterHotkey(this)
 *   }
 *   disconnect() {
 *     this.removeFilterHotkey?.()
 *   }
 */
export function installFilterHotkey(controller) {
  const handler = (event) => {
    // Synthetic non-KeyboardEvents dispatched by browser extensions carry no `key`
    // and read `undefined` for every modifier. A real keypress always carries a
    // string `key`, so requiring one rejects them outright. LUC-713.
    if (typeof event.key !== "string") return
    if (event.defaultPrevented || event.repeat) return
    if (event.metaKey || event.ctrlKey || event.altKey) return
    if (event.key.toLowerCase() !== "f") return

    // `instanceof Element` rather than optional chaining: an event dispatched on
    // `document` has a non-null target that has no `closest` method. LUC-713.
    const target = event.target
    if (target instanceof Element && target.closest("input, textarea, select, [contenteditable='true']")) return

    event.preventDefault()
    const isOpen = isPopoverOpen(controller.filterMenuTarget)
    isOpen ? controller.closeFilterMenu() : controller.openFilterMenu()
  }

  document.addEventListener("keydown", handler)
  return () => document.removeEventListener("keydown", handler)
}
